<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" @submit.prevent="save">
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="excepUploadModel">
              엑셀업로드
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="updateAsReturn">
              군공반려
            </el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label-width="0px">
                <el-row>
                  <el-col>
                    <el-form-item label="접수기간">
                      <el-col :span="10">
                        <el-date-picker type="date" placeholder="Pick a date" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                      <el-col :span="1" style="text-align: start;">-</el-col>
                      <el-col :span="10">
                        <el-date-picker type="date" placeholder="Pick a date" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                      </el-col>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="AS지역/AS센터" label-width="134px">
                <el-col :span="12">
                  <el-select v-model="form.area" @change="getCombo1">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in areaIdList"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">{{ item.value }}
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="12">
                  <el-select v-model="form.asAgent" v-show="showAsAgent2">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in asAgentIdList"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">{{ item.value }}
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="처리유형">
                <el-select v-model="form.asStatus" @change="getCombo2">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in asStatusIdList"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">{{ item.value }}
                  </el-option>
                </el-select>
                <el-select v-model="form.asStatus2" v-show="showAsStatus2">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in asStatus2List"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">{{ item.value }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item :label="$i18n.messages[$store.state.locale].siteNm" label-width="134px">
                <el-row>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm1"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm2"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm3"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                row-selection="single"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :context="context"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
/**
 * * Modal
 */
import ArmyCallUploadModal from '@/components/AS/ArmyCall/Modal/ArmyCallUploadModal.vue';


function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}


function _phone(hp){
    return hp ? hp.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3" ) : ''
}


export default {
  props: {
  },
  data() {
    return {
      data: [],
      form: {
        companyId : '',
        startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        callType: '',
        siteType: '',
        catId: 0,
        creatorId: 0,
        area: '',                   // AS지역/AS센터
        asAgent: '',                // AS지역/AS센터
        asStatus: '',               // 처리유형
        asStatus2: '',               // 처리유형
        siteNm1 : '',              // 사이트명1
        siteNm2 : '',              // 사이트명2
        siteNm3 : '',              // 사이트명3
        sortType :  '',
        processTime : '',
        page: 1,
        totalpage: 9999,
        totalcount: 9999,
        curPage: 0,
        processTime: ''
      },
      areaList: [], // AS지역/AS센터
      areaIdList: [], // AS지역/AS센터 ID
      asAgentIdList: [], // AS지역/AS센터
      asStatusList: [], // 처리유형
      asStatusIdList: [], // 처리유형 ID
      asStatus2List: [], // 처리유형2
      showAsAgent2: false, // AS지역/AS센터2
      showAsStatus2: false,
      startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 20px; width: 100%;height: 700px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:false
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      context: {
        //checkbox 전체 체크 이벤트 추가
        headerAllCheckEvent: this.allCheckEvnet
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.createMainColumnDefs();
      this.getCombo({callBy : 'INIT'});
    },
    /**
     * grid 내에 체크박스 전체 체크 함수
     * @param {*} field 
     * @param {*} checked 
     */
      allCheckEvnet(field, checked) {
      return this.data = this.data.map(x => {
          if(x.asStatus !== 'K') {
              x[field] = checked ? 'Y' : 'N';
          }
          return x;
      })
    },
    getCheckReadOnly(params){
      const vAsStatus = params.data.asStatus;
      // console.log('getCheckReadOnly aaa: ', vAsStatus, params)
      // K일때만 활성화
      if(vAsStatus === 'K'){
        return false;
      } else {
        return true;
      }
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
            headerName:'전체',
            field:'chk', 
            width:80,
            headerComponent: `checkBox`,
            headerComponentParams: (params) => {
              return params;
            },
            cellStyle:{textAlign: 'center'},
            cellRenderer: 'checkBox',
            ellRendererParams: {
                  trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
                , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
                , disable: true
            },
            cellRendererParams: (params) => {
              return {
                trueValue: 'Y',
                falseValue: 'N',
                disable: this.getCheckReadOnly(params)
              }
            }
        },
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'신고일자', field:'callDt', width:120, cellStyle:{textAlign: 'center'}, cellRenderer: 'datePicker'},
        {headerName:'신고번호', field:'asId', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'접수번호', field:'asId', width:150, cellStyle:{textAlign: 'left'}},
        {headerName:'부대명', field:'siteNm', width:150},
        {headerName:'신고자명', field:'boundCustNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'주소', field:'addr', width:210, cellStyle:{textAlign: 'center'}},
        {headerName:'연락처', field:'boundTelNo', width:150, cellStyle:{textAlign: 'center'}},
        {headerName:'처리센터', field:'allocationAsAgentNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'처리유형', field:'asStatus', width:120, cellStyle:{textAlign: 'center'}, hide: true},
        {headerName:'처리유형', field:'asStatusNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'처리일시', field:'callDt', width:120, cellStyle:{textAlign: 'center'}, cellRenderer: 'datePicker'},
        
      ];
    },
    
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this
      this.form.catId = 0

      console.log('this.areaList: ', this.areaList, this.areaIdList)
      //AS지역/AS센터가 두번째가 존재할 경우 두번째값으로 없으면 첫번째 값 대입처리
      let vCatId = this.form.asAgent
      if(vCatId === ''){
        vCatId = this.form.area
        // const vIdx = this.areaIdList.findIndex(x=>x.key == vCatId)
        // vCatId = this.areaList[vIdx].key || 0
      }

      //처리유형이 두번째가 존재할 경우 두번째값으로 없으면 첫번째 값 대입처리
      let vAsStatus = this.form.asStatus2
      if(vAsStatus === ''){
        vAsStatus = this.form.asStatus
        if(vAsStatus !== ''){
          const vIdx = this.asStatusIdList.findIndex(x=>x.key === vAsStatus)
          vAsStatus = this.asStatusList[vIdx].key || 0
        }
      }
      
      const vform = {
        ...this.form,
        catId : vCatId,
        asStatus : vAsStatus
      }

      console.log('goOpen passed this.form: ', vform)
      this.$store.commit('loading')

      this.$http.post(_url("/api/asMng/armyCallList/list"), vform).then(response => {
        console.log('response.data' , response.data)
        this.data = response.data.map(x=>{
          x.boundTelNo = _phone(x.boundTelNo);
          const vobj = this.asStatusList.filter(y=>y.key===x.asStatus);
          if(vobj && vobj.length>0){
            x.asStatusNm = vobj[0].value;
            x.siteNm = (x.siteNm1 || '') + ' ' + (x.siteNm2 || '') + ' ' + (x.siteNm3 || '');
          }
          
          return x;
        });

      }).finally(() => {
        this.$store.commit('finish')
      });
    },
    save() {
      console.log('test',this.$parent.$refs.step.next())
    },
    getCombo1(param) {
        /** AS지역/AS센터 콤보 변경시 */
        this.getCombo({callBy : 'AREA', child1: param})
    },
    getCombo2(param) {
        /** 처리유형 콤보 변경시 */
        console.log('getCombo2 start')
        this.getCombo({callBy : 'STATUS', child1: param})
    },
    getCombo(param){

      if(param.callBy === 'INIT'){
        // AS지역/AS센터 : AreaAgent 1레벨
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 217}})
          .then(response => {
              this.areaList = response.data || []
          })
          .finally(() => {});

        // AS지역/AS센터 ID: AreaAgent 1레벨
        this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 217}})
          .then(response => {
              this.areaIdList = response.data || []
          })
          .finally(() => {});
          
        // 처리유형 : AsStatus 1레벨
        this.$http.get(`/api/codeMng/combo`, {params: {parentId: 338}})
          .then(response => {
              this.asStatusList = response.data || []
          })
          .finally(() => {});

        // 처리유형 ID: AsStatus 1레벨
        this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: 338}})
          .then(response => {
              this.asStatusIdList = response.data || []
          })
          .finally(() => {});  

      } else if(param.callBy === 'AREA'){

        if(this.form.area===''){
          this.asAgentIdList = [];
          this.asAgentIdList = [];
          this.showAsAgent2 = false;
          this.form.asAgent = '';

        } else {
          this.$http.get(`/api/codeMng/combo/catId`, {params: {parentId: this.form.area}})
            .then(response => {
                this.asAgentIdList = response.data || [];
                this.showAsAgent2 = true
            })
            .finally(() => {
              this.form.asAgent = '';
            });
        }
        

      } else if(param.callBy === 'STATUS'){

        this.form.asStatus2 = '';
        this.showAsStatus2 = false;

        if(this.form.asStatus===''){
          this.asStatus2List = [];
          
        } else {
          this.$http.get(`/api/codeMng/combo`, {params: {parentId: this.form.asStatus}})
            .then(response => {
                this.asStatus2List = response.data || [];
                this.showAsStatus2 = (this.asStatus2List.length == 0) ? false : true;
            })
            .finally(() => {});
        }
        
      }
      
    },
    updateAsReturn(){
      // 군공반려

      let arrAsId = [];
      const vChkObj = this.data.filter(x=>x.chk==='Y').map(y=>{
        arrAsId.push(y.asId)
        return y;
      });

      if(!arrAsId || arrAsId.length === 0){
        this.$swal({ type: 'warning', text: '군공반려건을 선택해주십시요.' })
        return false;
      }

      this.$swal({
          type: 'warning',
          text: `군공반려를 하시겠습니까?`,
          showCancelButton: true,
          confirmButtonText: '예',
          cancelButtonText: '아니오',
      }).then((result) => {
          if (result.value) {
            const vSaveform = {
              asIdList: arrAsId
            }
console.log('vSaveform vSaveform : ', vSaveform)
            this.$store.commit('loading')
            this.$http.put("/api/asMng/armyCallList/updateAsAgentReupt", vSaveform)
                .then(response => {
                    let vMsgStr = '군공반려 되었습니다.'
                    this.$swal({ type: 'success', text: vMsgStr });
                    
                }).catch((e) => {
                    //console.error(e);
                    //this.$swal({ type: 'success', text: '저장에 실패 했습니다.' })
                })
                .finally(() => {
                    this.$store.commit('finish')
                });

          }
      });

    },
    excepUploadModel(){
      /** 엑셀업로드 */
      let vm = this;
      this.$modal.open({
          width: 800,
          component: ArmyCallUploadModal,
          parent: this,
          props: {
              data: {
                  
              },
          },
          events: {
              close(param) {
                  console.log('close', param);
                  vm.form.maker = param.data.maker /** 제조사 */
                  vm.form.makerNm = param.data.makerNm /** 제조사명 */
                  vm.form.modelGroupNm = param.data.modelGroupNm /** 모델그룹명 */
                  vm.form.modelGroup = param.data.modelGroup /** 모델그룹 */
                  vm.form.standardModelNm = param.data.standardModelNm /** 표준모델 */
                  vm.form.modelNm = param.data.modelNm /** 모델명 */
                  vm.form.modelId = param.data.modelId /** 모델ID */
              },
          }
      });

  },


  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    console.log('search', this.search);
    this.form.companyId = this.$store.state.loginInfo.compCd;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>